import { Select as BaseSelect } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseSelect)
